export type ExtraPermissionName
    = 'media'
    | 'appointment'
    | 'assignment'
    | 'chance'
    | 'client'
    | 'contact'
    | 'contract'
    | 'customer'
    | 'log'
    | 'note'
    | 'overview'
    | 'settings'
    | 'task';

export class PermissionManager {
    public readonly permissions: string[];

    constructor(permissions: string[]) {
        this.permissions = permissions;

    }
}

/** DEFAULT_OPTIONS */
const D_O = ['none', 'self', 'all'];
const BOOL = ['none', 'self'];
const CRUD = { create: ['none', 'all'], read: D_O, update: D_O, delete: D_O };

export const permissions = {
    'roles.general': [
        { name: 'customers.title', key: 'customer', ...CRUD, read: ['self', 'all'] },
        { name: 'contacts.title', key: 'contact', ...CRUD },
        { name: 'appointments.title', key: 'appointment', ...CRUD },
        { name: 'tasks.title', key: 'task', ...CRUD },
        { name: 'notes.notes', key: 'note', ...CRUD },
        { name: 'emails.emails', key: 'email', ...CRUD },
    ],
    'financial.title': [
        { name: 'chances.title', key: 'chance', ...CRUD },
        { name: 'assignment.title', key: 'assignment', ...CRUD },
        { name: 'contracts.title', key: 'contract', ...CRUD },
    ],
    'basic.miscellaneous': [
        { name: 'appendixes.title', key: 'media', ...CRUD },
        { name: 'roles.extra_info', key: 'field', create: BOOL, read: [], update: BOOL, delete: BOOL },
        { name: 'templates.template', key: 'template', create: BOOL, read: [], update: BOOL, delete: BOOL },
        { name: 'basic.export', key: 'export', create: BOOL, read: [], update: [], delete: [] },
        { name: 'basic.import', key: 'import', create: BOOL, read: [], update: [], delete: [] },
        { name: 'settings.log.title', key: 'log', create: [], read: BOOL, update: [], delete: [] },
        { name: 'notes.overview', key: 'overview_note', create: [], read: BOOL, update: [], delete: [] },
    ],
};
